const extractor = (name) => process.env[`REACT_APP_${name}`]

const configurationAuth0 = {
  domain: extractor('WEB_AUTH_DOMAIN'),
  clientID: extractor('WEB_AUTH_CLIENT_ID'),
  responseType: extractor('WEB_AUTH_RESPONSE_TYPE'),
  audience: extractor('WEB_AUTH_AUDIENCE'),
  scope: extractor('WEB_AUTH_SCOPE'),
  redirectUri: extractor('WEB_AUTH_REDIRECT_URI')
}

const basePathConfiguration = extractor('BASEPATH')

const demoApp = extractor('DEMO_VERSION')

const netlifyExtractor = original => {
  const isBranchDeploy = extractor('NETLIFY_CONTEXT') === 'branch-deploy'
  let url = extractor('NETLIFY_URL')
  if (isBranchDeploy) {
    url = url.replace('www', extractor('NETLIFY_BRANCH'))
  }
  console.info(url)
  return Object.assign(original, {redirectUri: `${url}/login`})
}

const configAuth = () => {
  if (extractor('IS_NETLIFY')) {
    return netlifyExtractor(configurationAuth0)
  }
  return configurationAuth0
}

const configurationNameSpace = extractor('TOKEN_NAMESPACE')

export { configAuth, basePathConfiguration, demoApp, configurationNameSpace }
